import React from 'react'
import style from './marketingSection.module.scss'
import { VegaHeading } from '../../vega/heading/Heading'
import { VegaIcon } from '../../vega/icon/Icon'
import { useTranslation } from 'react-i18next'
import { PropTypes } from 'prop-types'

/**
 * Marketing form description datas
 */
export const MarketingFormSectionDatas = {
	title: 'mktTitle',
	subtitle: 'mktSubtitle',
	description1: 'mktDescriptionLine1',
	description2: 'mktDescriptionLine2',
	description3: 'mktDescriptionLine3'
}

/**
 * Marketing card datas on the main ptr page
 */
export const MarketingModuleDatas = {
	title: 'mktModuleTitle',
	subtitle: 'mktModuleDescription',
	description1: 'mktModuleLine1',
	description2: 'mktModuleLine2',
	description3: 'mktModuleLine3'
}

/**
 * Marketing blocks
 */
const MarketingSection = ({
	title,
	subtitle,
	description1,
	description2,
	description3
}) => {
	const { t } = useTranslation()

	return (
		<>
			<VegaHeading tag="h4" label={t(title)} className={style.title} />
			<p>{t(subtitle)}</p>
			{description1 && (
				<div className={style.iconRow}>
					<VegaIcon name="payment-forward" size={20} className={style.icon} />
					{t(description1)}
				</div>
			)}
			{description2 && (
				<div className={style.iconRow}>
					<VegaIcon name="double-check" size={20} className={style.icon} />
					{t(description2)}
				</div>
			)}
			{description3 && (
				<div className={style.iconRow}>
					<VegaIcon name="receipt" size={20} className={style.icon} />
					{t(description3)}
				</div>
			)}
		</>
	)
}
MarketingSection.propTypes = {
	/** Set a bold title */
	title: PropTypes.string,
	/** Set description paragraph */
	subtitle: PropTypes.string,
	/** Set the value of the first description point */
	description1: PropTypes.string,
	/** Set the value of the second description point */
	description2: PropTypes.string,
	/** Set the value of the third description point */
	description3: PropTypes.string
}

export { MarketingSection }
